import { AffinitiesModule } from './affinities/routes'
import { AssistancesModule } from './assistances/routes'
import { DentalModule } from './dental/routes'
import { GadgetModule } from './gadget/routes'
import { LifeModule } from './life/routes'
import { LifeticketModule } from './lifeticket/routes'
import { MainModule } from './main/routes'
import { PrivateConsignedModule } from './privateConsigned/routes'
import { TravelModule } from './travel/routes'

const ModulesRoutes: React.FC = () => (
  <>
    <MainModule />
    <AffinitiesModule />
    <PrivateConsignedModule />
    <AssistancesModule />
    <LifeticketModule />
    <TravelModule />
    <GadgetModule />
    <DentalModule />
    <LifeModule />
  </>
)

export default ModulesRoutes
